import Settings from 'Settings'
import {ensureUrlCorrectSlashes} from '@daedalus/core/src/utils/url'

const bofhApiUrl = (segment: string) => {
  return ensureUrlCorrectSlashes([
    Settings.get('REACT_APP_BOFH_ENDPOINT'),
    segment
  ])
}

export default bofhApiUrl
